import React from 'react'
import { DemoDevice, GeneralCardProps } from '@/components'
import { apps } from '../data'
import CardComponents from './components'

const CherryMobileCard = (props: GeneralCardProps) => {

  const {
    onSelect,
    position = 'left',
  } = props

  const data = apps['cherry-mobile']

  return (
    <CardComponents.AppRow
      elemName={'cherry'}
      background={data.background}
      position={position}
    >
      <CardComponents.AppDescription data={data} position={position}/>
      <DemoDevice.DemoRow
        data={data}
        onSelect={onSelect}
        position={'left'}
      />
    </CardComponents.AppRow>
  )
}

export default CherryMobileCard
